module.exports = __webpack_public_path__ + "static/img/xl_btn2.10f98fa.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/home/pc/role3/control/xl_btn2.png
// module id = 1zyz
// module chunks = 7